export const APP_LANG = document.documentElement.lang;
export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const SHOW_ERROR = 'SHOW_ERROR'
export const HIDE_ERROR = 'HIDE_ERROR'
export const PAGES_REQUEST = 'PAGES_REQUEST'
export const MAIN_REQUEST = 'MAIN_REQUEST'
export const SET_APP_DATA = 'SET_APP_DATA'
export const CHANGE_SEARCH = 'CHANGE_SEARCH'
export const CATEGORY_SELECT = 'CATEGORY_SELECT'
export const AIR_CATEGORIES = 'AIR_CATEGORIES'
export const MOBILE_TRACKING_CHANGE = 'MOBILE_TRACKING_CHANGE'
export const EXCLUSIVE_CHANGE = 'EXCLUSIVE_CHANGE'
export const HOT_DEAL_CHANGE = 'HOT_DEAL_CHANGE'
export const RESET_FILTERS = 'RESET_FILTERS'
export const SUBSCRIBE_SET = 'SUBSCRIBE_SET'
export const AIR_CONFIG = 'AIR_CONFIG'
export const SEARCH_ITEMS = 'SEARCH_ITEMS'
export const MOBILE_MENU = 'MOBILE_MENU'
export const MOBILE_FILTER = 'MOBILE_FILTER'
export const MOBILE_GUIDES = 'MOBILE_GUIDES'
export const TOGGLE_INFO = 'TOGGLE_INFO'
export const FORM_BRANDS_NAME = 'FORM_BRANDS_NAME'
export const FORM_EMAIL = 'FORM_EMAIL'
export const FORM_POLICY = 'FORM_POLICY'
export const FORM_SUBSCRIBE = 'FORM_SUBSCRIBE'
export const FORM_SUBMIT = 'FORM_SUBMIT'


